// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.item-carousel-container{
    width: 40%;
}

.item-carousel{
    height: 11.5em;
    border-radius: 0.5em;
    overflow-x: auto;
    overflow-y: hidden;
    border: 0.2rem solid rgb(90, 90, 90);
    background-color: rgba(0, 0, 0, 0.6);
    box-shadow: rgba(0, 0, 0, 0.25) 0px 54px 55px, rgba(0, 0, 0, 0.12) 0px -12px 30px, rgba(0, 0, 0, 0.12) 0px 4px 6px, rgba(0, 0, 0, 0.17) 0px 12px 13px, rgba(0, 0, 0, 0.09) 0px -3px 5px;
}

.item-carousel .item-card-wrap{
    height: 10em !important;
    width: 15em !important;
    min-width: 15em !important
}

.item-carousel .item-card:first-child{
    margin-left: 0.5rem;
}

.item-carousel {
    -ms-overflow-style: none;  /* Internet Explorer 10+ */
    scrollbar-width: none;  /* Firefox */
}
.item-carousel::-webkit-scrollbar { 
    display: none;  /* Safari and Chrome */
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/ItemCarousel.css"],"names":[],"mappings":"AAAA;IACI,UAAU;AACd;;AAEA;IACI,cAAc;IACd,oBAAoB;IACpB,gBAAgB;IAChB,kBAAkB;IAClB,oCAAoC;IACpC,oCAAoC;IACpC,uLAAuL;AAC3L;;AAEA;IACI,uBAAuB;IACvB,sBAAsB;IACtB;AACJ;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,wBAAwB,GAAG,0BAA0B;IACrD,qBAAqB,GAAG,YAAY;AACxC;AACA;IACI,aAAa,GAAG,sBAAsB;AAC1C","sourcesContent":[".item-carousel-container{\n    width: 40%;\n}\n\n.item-carousel{\n    height: 11.5em;\n    border-radius: 0.5em;\n    overflow-x: auto;\n    overflow-y: hidden;\n    border: 0.2rem solid rgb(90, 90, 90);\n    background-color: rgba(0, 0, 0, 0.6);\n    box-shadow: rgba(0, 0, 0, 0.25) 0px 54px 55px, rgba(0, 0, 0, 0.12) 0px -12px 30px, rgba(0, 0, 0, 0.12) 0px 4px 6px, rgba(0, 0, 0, 0.17) 0px 12px 13px, rgba(0, 0, 0, 0.09) 0px -3px 5px;\n}\n\n.item-carousel .item-card-wrap{\n    height: 10em !important;\n    width: 15em !important;\n    min-width: 15em !important\n}\n\n.item-carousel .item-card:first-child{\n    margin-left: 0.5rem;\n}\n\n.item-carousel {\n    -ms-overflow-style: none;  /* Internet Explorer 10+ */\n    scrollbar-width: none;  /* Firefox */\n}\n.item-carousel::-webkit-scrollbar { \n    display: none;  /* Safari and Chrome */\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
